import styles from '../TopUpStatusAlertBox.module.css';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { TopUpStatusAlertBox } from './TopUpStatusAlertBox';
import messages from '../../../OutstandingView/dashboardActions/TopUpApproved/TopUpApproved.messages';
import { Rate } from '../../../../../myAccount/ui/rate';
import { Button, Icon } from '@iwoca/orion';
import { H2, Text } from '@ui';
import classNames from 'classnames';
import { getCountry } from '@iwIntlProvider/CountryProvider';

export const TopUpApprovedAlert = ({
    approvalAmount,
    timeoutDate,
    interestRate,
    onAccessFundsClick,
    branch
}: {
    approvalAmount: number;
    timeoutDate: string;
    interestRate: number;
    onAccessFundsClick: () => void;
    branch: string;
}) => {
    if (getCountry() === 'UK' && branch === 'INCLUDE')
        return (
            // tailwind bg-gradient does not work without @tailwind-base. Seems to be a create react app problem due to being opinionated on postcss
            // https://github.com/tailwindlabs/tailwindcss/issues/8597#issuecomment-1153032793
            <div
                data-testid="topup-approved-banner-redesign"
                className={classNames(
                    'flex items-start gap-s rounded-m p-m min-sm:gap-l min-sm:p-l',
                    styles.approvedGradient
                )}
            >
                <Icon
                    icon="rocket"
                    className="mt-xs size-xl shrink-0 fill-structure-100"
                />
                <div className="space-y-m">
                    <div className="space-y-s min-sm:space-y-xs">
                        <H2 className="text-xl font-bold text-structure-100">
                            <FormattedMessage {...messages.title} />
                        </H2>

                        <Text className="text-s text-structure-100 min-sm:text-m">
                            <FormattedMessage
                                {...messages.description}
                                values={{
                                    amount: (
                                        <FormattedCurrency
                                            value={approvalAmount}
                                        />
                                    ),
                                    interestRate: <Rate value={interestRate} />,
                                    expiryDate: (
                                        <FormattedDate
                                            value={timeoutDate}
                                            day="2-digit"
                                            month="short"
                                            year="numeric"
                                        />
                                    )
                                }}
                            />
                        </Text>
                    </div>

                    <Button
                        variant="secondary-alt"
                        onClick={onAccessFundsClick}
                    >
                        <FormattedMessage {...messages.accessfundsCTAText} />
                    </Button>
                </div>
            </div>
        );

    return (
        <TopUpStatusAlertBox
            variant="success"
            iconName="rocket"
            className={styles.approvedAlert}
            description={
                <>
                    <strong>
                        <FormattedMessage {...messages.title} />
                    </strong>{' '}
                    <FormattedMessage
                        {...messages.description}
                        values={{
                            amount: (
                                <strong>
                                    <FormattedCurrency value={approvalAmount} />
                                </strong>
                            ),
                            interestRate: (
                                <strong>
                                    <Rate value={interestRate} />
                                </strong>
                            ),
                            expiryDate: (
                                <strong>
                                    <FormattedDate
                                        value={timeoutDate}
                                        day="2-digit"
                                        month="short"
                                        year="numeric"
                                    />
                                </strong>
                            )
                        }}
                    />
                </>
            }
            cta={
                <Button variant="tertiary" onClick={onAccessFundsClick}>
                    <FormattedMessage {...messages.accessfundsCTAText} />
                    <Icon icon="angleRight" />
                </Button>
            }
        />
    );
};
